import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlarmsqueryService } from '../service/alarmsquery.service';
import { MarkersService } from '../service/markers.service';
import { MatTableDataSource } from '@angular/material/table';
import { startWith, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

export interface DialogData {
  uid?: string
  process?: string
}

@Component({
  selector: 'app-datainput',
  templateUrl: './datainput.component.html',
  styleUrls: ['./datainput.component.css']
})
export class DatainputComponent implements OnInit {
  
  @ViewChild('search', { static: false }) searchElementRef: ElementRef;
  SearchBarControl = new FormControl();
  public MonthdateControl2 = new FormControl();
  public today = new Date();

  public Theaders = ['date', 'place', 'gas', 'diesel', 'sales', 'button1'];
  public ODList = [];
  public ODData = new MatTableDataSource;
  public filteredODData: Observable<any[]>;


  constructor(public dialog: MatDialog, private dataService: AlarmsqueryService,private snack: MatSnackBar, private alarmsSrv: AlarmsqueryService) { }

  ngOnInit() {
    let sub = this.dataService.getOtherData().subscribe(result =>{
      this.ODList = [];
      for(let i in result){
        this.ODList.push({date: result[i]['Fecha'], place: result[i]['Place'],gas: result[i]['Gas'], diesel: result[i]['Diesel'], sales: result[i]['Ventas'], id: result[i]['id']})
      }
      console.log(this.ODList);
      this.ODData = new MatTableDataSource(this.ODList);
      this.filteredODData = this.SearchBarControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value))
      )

    })

  }

  //funcion para filtrar los sites
  private _filter(value: string): Object[] {
    this.ODData.filter = value.trim().toLowerCase();
    let result: object[] = [];
    for (let index = 0; index < this.ODData.filteredData.length; index++) {
      result.push({'date': this.ODData.filteredData[index]['date'], 'place': this.ODData.filteredData[index]['place'], 'sales': this.ODData.filteredData[index]['sales'], 'gas': this.ODData.filteredData[index]['gas'], 'diesel': this.ODData.filteredData[index]['diesel'] });
    }
    console.log(result)
    return result;
    // return [{"s": "a"}]
  }

  openDatePicker(dp) {
    dp.open();
  }

  closeDatePicker2(eventData: any, dp?:any) {
    // get month and year from eventData and close datepicker, thus not allowing user to select date
    let date = new Date(eventData);
    let year = date.getFullYear().toString();
    let month = (date.getMonth() + 1).toString();
    month = month.length > 1 ? month : '0' + month;
    let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);
    let fulldate = [year, month, 1].join('-');
    console.log(lastDayOfMonth);
    this.MonthdateControl2.setValue( lastDayOfMonth );
    this.MonthdateControl2.updateValueAndValidity();
    dp.close();
  }

  removeItem(index){
    const dialogRef = this.dialog.open(ConfirmDialog, {
      width: 'auto',
      data: {process: 'Delete'}
    });

    dialogRef.afterClosed().subscribe(result =>{
      if (result == 'ok'){
        this.alarmsSrv.delteOtherData(this.ODList[index].id);
      }
    })
  }

  //-----------Abre ventana de Nuevo beneficiario----------------
  openNewDialog(event, usr): void {
    const dialogRef = this.dialog.open(NewEditData, {
      width: '98vw',
      data: {user: usr, process: 'Nuevo'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "created"){this.snack.open('Nuevo dato creado', '', {duration: 2000})}
    });
  }

  //-----------Abre ventana de Nuevo beneficiario----------------
  openEditDialog(event, usr): void {
    usr = this.ODList[usr];
    const dialogRef = this.dialog.open(NewEditData, {
      width: '98vw',
      data: {user: usr, process: 'Editar'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "edited"){this.snack.open('Dato editado', '', {duration: 2000})}
    });
  }

}

@Component({
  selector: 'new-edit-data',
  templateUrl: 'new-edit-data.html',
  styleUrls: ['new-edit-data.css']
})
export class NewEditData implements OnInit{
  public process: string;
  public user: {};
  public places = [];

  public MonthdateControl2 = new FormControl();
  public today = new Date();

  public placesControl = new FormControl();
  public GasInput = '0';
  public DieselInput = '0';
  public SalesInput = '0';
  public placesModel = '';
  public id = '';


  constructor(public dialogRef: MatDialogRef<NewEditData>,private placesService: MarkersService, private alarmsSrv: AlarmsqueryService,
  @Inject(MAT_DIALOG_DATA) public data: DialogData)
  {
    if(this.data["usr"] != undefined)
    {
      this.user = this.data["usr"];
      console.log(this.user);
    }
    this.process = this.data.process;
  }
 
  ngOnInit(){
    let sub = this.placesService.getMarkers().subscribe(result =>{
      this.places = [];
      for(let i in result){
        this.places.push(result[i]['zone']+'-'+result[i]['city']+'-'+result[i]['office'])
      }

      if(this.process == 'Editar'){
        console.log(this.data['user']);
        this.GasInput = this.data['user']['gas'];
        this.DieselInput = this.data['user']['diesel'];
        this.SalesInput = this.data['user']['sales'];
        this.placesModel = this.data['user']['place'];
        this.id = this.data['user']['id'];
        let date = new Date(this.data['user']['date']);
        date.setDate(date.getDate() + 1);
        this.MonthdateControl2.setValue(date);
      }

    })

  }

  openDatePicker(dp) {
    dp.open();
  }

  closeDatePicker2(eventData: any, dp?:any) {
    // get month and year from eventData and close datepicker, thus not allowing user to select date
    let date = new Date(eventData);
    let year = date.getFullYear().toString();
    let month = (date.getMonth() + 1).toString();
    month = month.length > 1 ? month : '0' + month;
    let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);
    let fulldate = [year, month, 1].join('-');
    console.log(lastDayOfMonth);
    this.MonthdateControl2.setValue( lastDayOfMonth );
    this.MonthdateControl2.updateValueAndValidity();
    dp.close();
  }

  pushData(){
    //fecha fin arreglo
    let date2 = this.MonthdateControl2.value;
    let lastDayOfMonth = new Date(date2.getFullYear(), date2.getMonth()+1, 0);
    let end = [lastDayOfMonth.getFullYear().toString(), (lastDayOfMonth.getMonth()+1).toString(), lastDayOfMonth.getDate().toString()].join('-');
    this.alarmsSrv.pushOtherData(end, this.placesModel, this.GasInput, this.DieselInput, this.SalesInput);
    this.dialogRef.close('created');
  }

  updateData(){
    //fecha fin arreglo
    let date2 = this.MonthdateControl2.value;
    let lastDayOfMonth = new Date(date2.getFullYear(), date2.getMonth()+1, 0);
    let end = [lastDayOfMonth.getFullYear().toString(), (lastDayOfMonth.getMonth()+1).toString(), lastDayOfMonth.getDate().toString()].join('-');
    this.alarmsSrv.updateOtherData(end, this.placesModel, this.GasInput, this.DieselInput, this.SalesInput, this.id);
    this.dialogRef.close('edited');
  }

}

@Component({
  selector: 'confirm-dialog',
  templateUrl: 'confirm-dialog.html',
  styleUrls: ['confirm-dialog.css']
})
export class ConfirmDialog{
  
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {console.log(data);}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
